<!-- =========================================================================================
  File Name: Payments.vue
  Description: Data List - List View for payments
========================================================================================== -->

<template>
  <div class="vx-row">
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
        <vx-card title="Details">
            <vs-input label="Name" :value="activeUserInfo.user_info.firstName + ' ' +activeUserInfo.user_info.lastName" type="text" class="w-full mb-4" disabled="true" />
            <vs-input label="Email" :value="activeUserInfo.user_info.email" type="email" class="w-full mb-4" disabled="true" />
            <vs-input label="Phone" :value="activeUserInfo.user_info.phone" type="email" class="w-full mb-4" disabled="true" />
            <!--<vs-button class="mr-4" @click="name = email = msg =''">Submit</vs-button>
             <vs-button type="border" color="warning" @click="name = email = msg =''" class="mt-3">Cancel</vs-button> -->
        </vx-card>
    </div>
    <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
          <vx-card title="Change Password">
            <div class="w-full mb-4">
              <vs-input label="Old Password" v-validate="'required'" type="password" class="w-full mb-1" name="old_password" v-model="old_password" />
              <span class="text-danger text-sm" v-show="errors.has('old_password')">{{ errors.first('old_password') }}</span>
            </div>

            <div class="w-full mb-4">
              <vs-input label="New Password" v-validate="'required|min:5'" type="password" class="w-full mb-1" name="new_password" v-model="new_password" ref="new_password" />
             <span class="text-danger text-sm" v-show="errors.has('new_password')">{{ errors.first('new_password') }}</span>
            </div>
            
            <div class="w-full mb-4">
              <vs-input label="Confirm Password" v-validate="'required|confirmed:new_password'" type="password" class="w-full mb-1" name="confirm_password" v-model="confirm_password" data-vv-as="new_password"  />
              <span class="text-danger text-sm" v-show="errors.has('confirm_password')">{{ errors.first('confirm_password') }}</span>
            </div>
            
            <vs-button class="mr-4" @click="changePassword()">Change</vs-button>
        </vx-card>
    </div>    
  </div>
</template>

<script>
// For custom error message
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    old_password: {
      required: 'Field is required'
    },
    new_password: {
      required: 'Field is required',
      min: 'Min 5 characters'
    },
    confirm_password: {
      required: 'Field is required',
      confirmed: 'Password does not matched'
    }
  }
}

// register custom messages
Validator.localize('en', dict)
export default {

  data () {
    return {
      old_password: '',
      new_password: '',
      confirm_password: '',
      custID: ''
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    changePassword () {

      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          const formData = new FormData()
          formData.append('old_password', this.old_password)
          formData.append('new_password', this.new_password)

          this.$http.post('/change-password/', formData, { headers: {'Content-Type': 'multipart/form-data' }})
            .then((response) => {
              if (response.data.messageType == 'success') {
                this.$vs.notify({title:'Great!', text:response.data.message, color:'success', position:'top-right', icon:'check_box', time:5000})
                this.$vs.loading.close()
                return true
              } else {
                this.$vs.loading.close()
                this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
                return true
              }

            })
            .catch((error)   => {
              console.log(error)
              this.$vs.loading.close()
              this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
              return this.staffMembers
            })

        } else { return false }
      })  
    }
  }
}
</script>

<style lang="scss">

</style>
